import axios from 'axios';

export function getStatisticsVesselPositions(from, until) {
    return axios({
        method: 'POST',
        url: '/api/v1/statistics/vesselPositions',
        data: {
            from,
            until,
        },
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}


// WEBPACK FOOTER //
// ./app/services/statistics/vesselPositions.js